module.exports = __webpack_public_path__ + "img/0-2.868c492f.png";